// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toggle-button {
    display: flex;
    align-items: center;
    width: var(--toggle-width);
    height: var(--toggle-height);
    border: 0.09375rem solid var(--secondary-color);
    border-radius: 0.75rem;
    overflow: hidden;
    cursor: pointer;
  }
  
  .divider {
    width: 0.125rem;
    height: 100%;
    background-color: black;
  }
  
  .toggle-option {
    flex: 1;
    text-align: center;
    line-height: var(--toggle-height);
    font-size: 1rem;
    transition: background-color 0.3s ease, color 0.3s ease;
  }
  
  .toggle-option.no {
    background-color: #ffffff;
  }
  
  .toggle-option.yes {
    background-color: #ffffff;
  }
  
  .toggle-option.active {
    background-color: var(--color-primary);
    color: #fff;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/common/ToggleButton/ToggleButton.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,0BAA0B;IAC1B,4BAA4B;IAC5B,+CAA+C;IAC/C,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,uBAAuB;EACzB;;EAEA;IACE,OAAO;IACP,kBAAkB;IAClB,iCAAiC;IACjC,eAAe;IACf,uDAAuD;EACzD;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,sCAAsC;IACtC,WAAW;EACb","sourcesContent":[".toggle-button {\n    display: flex;\n    align-items: center;\n    width: var(--toggle-width);\n    height: var(--toggle-height);\n    border: 0.09375rem solid var(--secondary-color);\n    border-radius: 0.75rem;\n    overflow: hidden;\n    cursor: pointer;\n  }\n  \n  .divider {\n    width: 0.125rem;\n    height: 100%;\n    background-color: black;\n  }\n  \n  .toggle-option {\n    flex: 1;\n    text-align: center;\n    line-height: var(--toggle-height);\n    font-size: 1rem;\n    transition: background-color 0.3s ease, color 0.3s ease;\n  }\n  \n  .toggle-option.no {\n    background-color: #ffffff;\n  }\n  \n  .toggle-option.yes {\n    background-color: #ffffff;\n  }\n  \n  .toggle-option.active {\n    background-color: var(--color-primary);\n    color: #fff;\n  }\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
